import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import isNil from 'ramda/src/isNil';
import CheckIcon from '@components/@core/CheckIcon';
import Pagination from '@components/@core/Pagination';
import Thumbnail from '@components/@core/Thumbnail';
import { inPage } from '~/services/util';

class TrainingsDetail extends React.PureComponent {
    state = { current: 1, per: 5 };

    handlePagination = (e) => {
        this.setState({ current: e });
    };

    handlePer = (e) => {
        this.setState({ per: e });
    };

    render() {
        const { current, per } = this.state;
        const { data, type } = this.props;

        return (
            <div className="career-required-instances">
                <div className="trainings">
                    <div className="list d-none d-sm-flex">
                        <div className="d-flex-8 dsl-m12">Course</div>
                        <div className="d-flex-1 dsl-m12 text-end">Modules</div>
                        <div className="d-flex-1 dsl-m12 text-end">Compl.</div>
                        <div className="d-flex-1 dsl-m12 text-end">Due</div>
                        <div className="d-flex-1 dsl-m12 ms-4">Status</div>
                    </div>
                    {data.map(
                        (item, index) =>
                            inPage(index, current, per) && (
                                <div className="list d-flex ssm-column" key={`tr-${index}`}>
                                    <div className="d-flex d-flex-8">
                                        <CheckIcon className="my-auto" size={26} checked={!isNil(item.completed_at)} />
                                        <Thumbnail source={item.data.thumb_url || item.thumbnail} size="tiny" />
                                        <div className="ml-4">
                                            <p className="dsl-b14 text-400 mb-1">{item.name || item.data.name || item.title}</p>
                                            <p className="dsl-m12 mb-0 text-400">Assigned: Career</p>
                                        </div>
                                    </div>
                                    <div className="d-flex-1 dsl-m12 text-end ssm-left py-2 ssp-y-0">
                                        <span className="dsl-b14 d-inline-block d-sm-none me-2 w-25 text-400">Module</span>
                                        <sapn>{item.data.module_count}</sapn>
                                    </div>
                                    <div className="d-flex-1 dsl-m12 text-end ssm-left py-2 ssp-y-0">
                                        <span className="dsl-b14 d-inline-block d-sm-none me-2 w-25 text-400">Compl.</span>
                                        <span>Na</span>
                                    </div>
                                    <div className="d-flex-1 dsl-m12 text-end ssm-left py-2 py-sm-0">
                                        <span className="dsl-b14 d-inline-block d-sm-none me-2 w-25 text-400">Due.</span>
                                        <span>{item?.due_at ? moment(item.due_at).format('MMM DD') : 'Na'}</span>
                                    </div>
                                    <div className="d-flex-1 dsl-m12 ms-4 ssm-l-0 py-2 py-sm-0">
                                        <span className="dsl-b14 d-inline-block d-sm-none me-2 w-25 text-400">Status</span>
                                        <span>{type === 'template' ? 'Na' : isNil(item.completed_at) ? 'In Progress' : 'Completed'}</span>
                                    </div>
                                </div>
                            )
                    )}
                </div>
                {data.length >= 10 && <Pagination current={current} per={per} pers={[5, 10, 'all']} total={Math.ceil(data.length / per)} onChange={this.handlePagination} onPer={this.handlePer} />}
            </div>
        );
    }
}

TrainingsDetail.propTypes = {
    data: PropTypes.array,
    type: PropTypes.oneOf(['instance', 'template']),
};

TrainingsDetail.defaultProps = {
    data: [],
    type: 'instance',
};

export default TrainingsDetail;
